export default __webpack_public_path__ + "static/media/slice-annotation-large.a2ac9ef6.png";